import { EPostbackStatus } from '../../../types'
import { IPostbackStatusLang } from '../../../types/lang'

export const postbackStatusLang: IPostbackStatusLang = {
	postback_status: {
		[EPostbackStatus.Lead]: 'lead_ua',
		[EPostbackStatus.Sale]: 'sale_ua',
		[EPostbackStatus.Reject]: 'reject_ua',
	}
}